// GENERATED FILE - DO NOT EDIT BY HAND.
// Source: data/YCP_AUTH_POLICY.json (the password policy of record; ruling 81, applied by ruling 184).
// Regenerate: node scripts/gen-auth-policy.js
//
// The live Identity Platform policy is applied from the same file by scripts\apply-auth-policy.js,
// and AUTH-1 fails if the live policy differs from it. So the words below, the rule Firebase
// enforces, and the verifier all read ONE source. The sign-in page must never carry a second copy.

export const MIN_LENGTH = 12;
export const REQUIRES = ["one lowercase letter","one number"];
export const NOT_REQUIRED = ["capitals","symbols"];

// One sentence a member can act on. Used on the sign-in page after a failed attempt and on the
// reset confirmation, BEFORE he reaches the reset page - so he chooses a valid password the first
// time instead of guessing, being refused, and starting the loop that locked Bob out twice.
export function rulesSentence() {
  let s = 'Your password must be at least ' + MIN_LENGTH + ' characters';
  if (REQUIRES.length) s += ', with at least ' + REQUIRES.join(' and ');
  s += '.';
  if (NOT_REQUIRED.length) s += ' No ' + NOT_REQUIRED.join(' or ') + ' needed.';
  return s;
}
